import type { RefObject } from 'react'

import { useEffect, useState } from 'react'

/* True while the element is on screen (with a margin), used to pause 3D scenes that nobody can see. */
export const useInView = <T extends Element>(ref: RefObject<T | null>, rootMargin = '160px'): boolean => {
    const [inView, setInView] = useState(false)

    useEffect(() => {
        const element = ref.current

        if (!element) return

        if (typeof IntersectionObserver === 'undefined') {
            setInView(true)
            return
        }

        const observer = new IntersectionObserver(([entry]) => setInView(entry.isIntersecting), { rootMargin })

        observer.observe(element)

        return () => observer.disconnect()
    }, [ref, rootMargin])

    return inView
}
